const cache = new Map<string, any>();

function logCache() {
  console.log('Cache keys in College Listing :', Array.from(cache.keys()));
  console.log('Total keys in cache:', cache.size);
}

// Set cache without expiry
export function setCollegeListingCache(key: string, data: any) {
  cache.set(key, data);
  console.log(`[College Listing Cache Save] Data cached for key: ${key}`);
  logCache();
}

// Get cached data
export function getCollegeListingCache<T>(key: string): T | null {
  if (cache.has(key)) {
    console.log(`[College Listing Cache Hit] Returning cached data for key: ${key}`);
    return cache.get(key);
  }
  return null;
}

// Remove specific cache by key
export function removeCollegeListingCache(key: string) {
  if (cache.has(key)) {
    cache.delete(key);
    console.log(`[College Listing Cache Delete] Removed cache for key: ${key}`);
  }
}

// Clear entire cache (called via cron or manually)
export function clearAllCollegeListingCache() {
  cache.clear();
  console.log(`[College Listing Cache Clear] Entire cache has been cleared.`);
}